var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DefaultPanel",
    {
      staticClass: "flight-panel",
      attrs: { title: "Volo selezionato", "is-selected": _vm.selected },
      scopedSlots: _vm._u([
        {
          key: "modal",
          fn: function() {
            return [
              _c("ModalFlightDetail", {
                ref: "modalFlightDetail",
                attrs: { value: _vm.value, selected: _vm.selected },
                on: { select: _vm.onSelect }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      [
        _c("FlightSection", {
          attrs: { selected: _vm.selected, value: _vm.value },
          on: { detail: _vm.onOpenDetail, select: _vm.onSelect }
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df2c020c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df2c020c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/FlightPanel.vue
// module id = null
// module chunks = 